import { US_STATES } from "../../lib/constants";
import { isPuertoRico, getPuertoRicoErrorMessage } from "../../lib/puerto-rico-check";

interface StateComboboxProps {
  value: string;
  onChange: (state: string) => void;
  label: string;
  placeholder: string;
  errorMessage?: string;
  language?: "en" | "es";
  className?: string;
  testId?: string;
}

export function StateCombobox({
  value,
  onChange,
  label,
  placeholder,
  errorMessage,
  language = "en",
  className = "",
  testId,
}: StateComboboxProps) {
  const isPR = isPuertoRico(value);
  const hasError = !!errorMessage || isPR;

  const displayError = errorMessage || (isPR ? getPuertoRicoErrorMessage(undefined, language) : "");

  return (
    <div className={className}>
      <label
        htmlFor="state-select"
        className="block mb-2 text-sm font-medium required-label"
        style={{ fontFamily: "TT Commons Pro" }}
      >
        {label}
      </label>

      <select
        id="state-select"
        name="state"
        autoComplete="address-level1"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        aria-required="true"
        aria-invalid={hasError}
        aria-describedby={hasError ? "state-error" : undefined}
        data-testid={testId}
        className={`w-full pl-3 pr-10 !py-[10.5px] !border-0 ring-1 ring-inset bg-white !text-[16px] leading-6 appearance-none cursor-pointer ${
          hasError ? "ring-[#E34D52]" : "ring-gray-300"
        } ${value ? "text-black" : "text-gray-400"}`}
        style={{
          fontFamily: "TT Commons Pro",
          borderRadius: "10px",
          paddingLeft: "12px",
          backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%236b7280'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M19 9l-7 7-7-7'%3E%3C/path%3E%3C/svg%3E")`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "right 0.75rem center",
          backgroundSize: "1.25rem",
          paddingRight: "2.5rem",
        }}
      >
        <option value="" disabled>
          {placeholder}
        </option>
        {US_STATES.map((state) => (
          <option key={state} value={state}>
            {state}
          </option>
        ))}
      </select>

      {displayError && (
        <div
          id="state-error"
          className="mt-2 rounded text-[#E34D52] text-sm leading-[21px]"
          style={{ fontFamily: "TT Commons Pro" }}
          role="alert"
          aria-live="assertive"
        >
          {displayError}
        </div>
      )}
    </div>
  );
}
